import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { AppUser } from '@kawai/shared';
import { fetchAllUsers } from '../repositories/users.js';

/**
 * LE-00 (promo): 自テナントの全顧客プロフィールを取得する React Query hook。
 *
 * cache key: `['promo', 'allUsers', tenantId]`
 * - tenantId が null/undefined の間は disabled（saas-admin は impersonation 経由で tenantId を得る）
 * - 一覧 / セグメント配信プレビューで共用
 */
export function useAllUsers(
  tenantId: string | null | undefined,
): UseQueryResult<AppUser[], Error> {
  return useQuery({
    queryKey: ['promo', 'allUsers', tenantId],
    queryFn: () => fetchAllUsers(tenantId as string),
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000,
  });
}
